// imports jquery only if it hasn't already been imported
if (window.$ == undefined || window.jQuery == undefined) window.$ = window.jQuery = require('jquery');
